<template>
    <div>
        <v-container>
            <notification-popup
                :dialog="notifQRFailed"
                :contentMsg="contentMsg"
                :headerMsg="$t('FailedQrGenerateHeader')"
                :nameBtnNo="$t('labelNo')"
                :nameBtnYes="$t('Back')"
                colorIcon="danger"
                typeModal="transaction"
                Icon="mdi-close-circle"
                disableBtnNo="true"
                imgSource="notification/failed.svg"
                :onHandlerYes="buttonBack"
            />

            <notification-popup  
                :dialog="modalUsageCPM"
                :contentMsg="$t('Enjoyyourtrip')"
                :headerMsg="$t('ValidationSuccess')"
                :nameBtnNo="$t('labelNo')"
                :nameBtnYes="labelOkSuccess"
                disableBtnNo="true"
                colorIcon = "success"
                typeModal="transaction"
                Icon="mdi-check-circle"
                imgSource="notification/success2.svg"
                :onHandlerNo="cancelSuccess"
                :onHandlerYes="buttonOke"
            />
            
            <v-card class="w-full mb-4">
                <div ref="qrRef" class="pa-2 px-4 pt-4">
                    <qrcode-vue :value="qrCode" :size="300" class="text-center"/>
                    <div class="mt-2 text-center">
                        <span class="f-bold" style="font-size: large;">{{ $t("ScanTicketOnBus") }}</span>
                    </div>
                </div>
                <div class="dots-line" />
                
                <div ref="qrRef" class="pa-2 px-4 pt-4">
                    <div class="text-center">
                        <span class="f-bold" style="font-size: large;">{{ $t("QR akan diperbarui dalam") }}</span>
                    </div>
                    <div class="text-center">
                        <span class="time-text">{{ secondes }}</span>
                        <span class="time-detail">Detik</span>
                    </div>
                </div>
                <div class="dots-line" />

                <div class="px-4 py-2 pb-4">
                    <div v-if="detailTicket != undefined">
                        <div class="d-flex flex-row justify-between" style="align-items: center;">
                            <span class="f-bold f-s-sm">{{ $t("DetailTicket") }}</span>
                            <div class="d-flex flex-column" style="font-size: x-small; text-align: right;">
                                <span>{{ $t("PurchaseDate") }}:</span>
                                <span>{{ detailTicket.success_time }}</span>
                            </div>
                        </div>

                        <div class="d-flex flex-column mb-2">
                            <span class="f-s-xs">{{ $t("TicketName") }}</span>
                            <span class="f-bold f-s-xs">{{ detailTicket.fare_name }}</span>
                        </div>

                        <div class="d-flex flex-column mb-2">
                            <span class="f-s-xs">{{ $t("ExpiredDate") }}</span>
                            <span class="f-bold f-s-xs">{{ expiredTicket }}</span>
                        </div>

                        <div v-if="[3, 4, 9, 10].includes(detailTicket.fare_type)" class="d-flex flex-column mb-2">
                            <span class="f-s-xs">{{ $t("TicketsRemaining") }}</span>
                            <span 
                                v-if="detailTicket.fare_rule.max_trip == 0" 
                                class="f-bold f-s-xs"
                            >{{ $t("UnlimitedTrips") }}</span>
                            <span 
                                v-else-if="$i18n.locale == 'vi' && detailTicket.fare_rule.max_trip != 0"
                                class="f-bold f-s-xs"
                            >Tập {{ detailTicket.fare_rule.max_trip }} vé</span>
                            <span 
                                v-else
                                class="f-bold f-s-xs"
                            >{{ (parseInt(detailTicket.max_trip) - detailTicket.used_ticket) + ' ' + $t("TimesPerTrip")}}</span>
                        </div>

                        <div class="d-flex flex-column mb-2">
                            <span class="f-s-xs">{{ $t("TicketStatus") }}</span>
                            <span v-if="isExpired" class="f-bold f-s-xs">{{ $t("Expired") }}</span>
                            <span v-else class="f-bold f-s-xs">{{ $t("TicketNotYetUsed") }}</span>
                        </div>
                    </div>

                    <div class="d-flex flex-row justify-between" style="gap: 12px;">
                        <div class="w-full">
                            <ac-button 
                                :small="true"
                                :name="$t('Refresh')" 
                                :on-click-handler="buttonRefresh"
                                outlined
                            />
                        </div>
                        <div class="w-full">
                            <ac-button 
                                :small="true"
                                :name="$t('Close')" 
                                :on-click-handler="buttonBack"
                            />
                        </div>
                    </div>
                </div>
            </v-card>
            <!-- <v-row class="mx-0 box mt-4" justify="center">
                <v-col cols="12">
                    <qrcode-vue :value="qrCode" :size="300" class="mt-10 mb-0 text-center"/>
                </v-col>
                <v-col class="text-center">
                    <v-btn
                        rounded
                        class="text-capitalize"
                        v-on:click="loadInitial"
                        :color="$partnerACL.getButtonColor()"
                        style="width: 120px;"
                    >
                        {{ $t("Refresh") }}
                    </v-btn>
                </v-col>
            </v-row> -->
        </v-container>
    </div>
</template>

<script>
import QrcodeVue from "qrcode.vue";
import NotificationPopup from "@/components/NotificationPopup.vue";
import AcButton from "@/components/AcButton";

export default {
    name: "ShowQRCode",
    components: {
        QrcodeVue,
        NotificationPopup,
        AcButton
    },
    data() {
        return {
            item: this.$route.params.item,
            ticketId: this.$route.params.data,
            detailTicket: this.$route.params.detail,
            expiredTicket: this.$route.params.expired_ticket,
            isExpired: this.$route.params.is_expired,
            qrCode: '',
            notifQRFailed: false,
            contentMsg: '',
            sliceTicket: this.$route.params.data,
            fareType: this.$route.params.fareType,
            method: this.$route.params.method,
            labelOkSuccess: this.$t('BacktoRecentTrip'),
            qrSucceedValidate: true,
            intervalId: null,
            secondes: String(Number(process.env.VUE_APP_QR_REFRESH_TIME) / 1000),
            time: Number(process.env.VUE_APP_QR_REFRESH_TIME) / 1000,
            timer: null,
            isRunning: false
        }
    },
    computed: {
        modalUsageCPM() {
            return this.$store.state.notification.modalUsage
        },
        checkFare() {
            return typeof this.ticketId == 'object'
        },
    },
    watch: {
        modalUsageCPM: function () {
            this.qrSucceedValidate = false
        },
        sliceTicket: {
            handler(latest) {
                if (this.checkFare && this.method == "one-by-one" && latest.length > 1) {
                    this.labelOkSuccess = this.$t('CloseForNextPassenger')
                } else {
                    this.labelOkSuccess = this.$t('BacktoRecentTrip')
                }
            },
            deep: true,
            immediate: true
        }
    },
    methods: {
        async generateQrCode(datas) {
            let ticketId = !datas ? this.ticketId : datas

            if (this.checkFare) {
                ticketId = ticketId[0]
            }
            const payload = {
                ticket_id: ticketId,
                bundling: this.method == "all" ? "1" : ""
            }
            await this.$store
                .dispatch("cpm/GenerateQR", payload)
                .then((response) => {
                    if (response.status) {
                        this.qrCode = response.data.data_qr
                        this.qrSucceedValidate = true
                    } else {
                        let message = response.message
                        if (message === '') {
                            message = 'PleaseTryAgain'
                        }
                        const splitmsg = message.split('-')
                        if (splitmsg.length > 1) {
                            this.contentMsg = `${this.$t(splitmsg[0])} ${this.$t(splitmsg[1])} ${this.$t(splitmsg[2])}`
                        } else {
                            this.contentMsg = this.$t(message)
                        }
                        this.notifQRFailed = true
                    }

                    if (this.timer == null) {
                        this.start()
                    }
                })
                .catch((err) => {
                    console.log(err);
                    // this.contentMsg = this.$t('PleaseTryAgain')
                    // this.notifQRFailed = true
                });
        },
        buttonRefresh() {
            this.stop()
            setTimeout(() => {
                this.reset()
            }, 500);
        },
        buttonBack() {
            this.$router.go(-1)
            this.$store.commit("notification/SET_MODAL_USAGE", false);
        },
        cancelSuccess() {
            this.$store.commit("notification/SET_MODAL_USAGE", false);
        },
        buttonOke() {
            this.$store.commit("notification/SET_MODAL_USAGE", false);
            if (this.method == "one-by-one" && this.sliceTicket.length > 1) {
                return
            } else {
                this.$router.push({ name: "MyTrip" });
            }
        },
        nextQr() {
            const length = this.sliceTicket.length
            if (length <= 0) {
                this.contentMsg = this.$t("AllTicketHasBeenValidated")
                this.notifQRFailed = true
                return
            }
            const shift = this.sliceTicket.slice(1, this.sliceTicket.length)
            this.sliceTicket = shift
            this.generateQrCode(shift)
        },
        refreshQR() {
            this.intervalId = setInterval(() => {
                this.generateQrCode()
            }, Number(process.env.VUE_APP_QR_REFRESH_TIME));
        },
        async downloadQR() {
            const element = this.$refs.qrRef;
            if (!element) return alert("Elemen belum siap!");

            // html2canvas sudah tersedia di window
            const canvas = await window.html2canvas(element, {
                scale: 2,
                backgroundColor: "#ffffff",
            });

            const link = document.createElement("a");
            link.download = "ticket_qr.png";
            link.href = canvas.toDataURL("image/png");
            link.click();
        },
        start() {
            this.isRunning = true
            if (!this.timer) {
                this.timer = setInterval(() => {
                    if (this.time > 0) {
                        this.time--

                        let hours = Math.floor(this.time / 3600)
                        let minutes = Math.floor((this.time - (hours * 3600)) / 60)
                        let secondes = Math.floor((this.time - ((hours * 3600) + (minutes * 60))))

                        this.secondes = this.pad(secondes)
                    } else {
                        this.buttonRefresh()
                    }
                }, 1000)
            }
        },
        stop() {
            this.isRunning = false
            clearInterval(this.timer)
            this.timer = null
        },
        reset() {
            this.time = 20
            this.secondes = '20'
            this.generateQrCode()
        },
        pad(timer) {
            if (timer < 10) {
                return '0' + timer
            }
            return timer
        },
    },
    mounted() {
        this.generateQrCode()
    },
    beforeDestroy() {
        clearInterval(this.intervalId)
        this.stop()
    },
}
</script>

<style lang="scss" scoped>
.box {
    background: #FFFFFF;
    border: 1px solid #4BB14E;
    border-radius: 10px;
    box-shadow: 0px 1px 2px rgb(0 0 0 / 10%), 0px 4px 8px rgb(0 0 0 / 5%);
}

.link {
    color: #4BB14E;
    text-decoration: underline;
}

.dots-line {
    border: 1px dashed #ccc;
}

.text-color-green {
    color: #489e4b;
}

.time-text {
  font-weight: bold;
  font-size: 30px;
}

.time-detail {
  font-size: 16px;
}
</style>